import React, { useEffect, useState } from 'react';
import interact from 'interactjs';
import { Tabs, Tab } from 'react-bootstrap';
import ChatWidget from './CallIcon/chatWidget';
import Minimize from '@mui/icons-material/CloseFullscreen';
import Maximize from '@mui/icons-material/OpenInFull';
import CallHistory from '../../../views/dashboard/desposition/callhistory';
import Form from '../../../views/dashboard/desposition/form';
import Recents from '../../../views/dashboard/desposition/recents';
import { FileEarmarkText, ClockHistory, Clock, FileEarmarkCode } from 'react-bootstrap-icons';

const HeaderModals = () => {
  const [status, setStatus] = useState("DISCONNECTED");
  const [activeModals, setActiveModals] = useState([]);
  const [isMinimized, setIsMinimized] = useState({});
  const [positions, setPositions] = useState({});
  const [agentToolsActiveTab, setAgentToolsActiveTab] = useState("disposition");
  const [zIndex, setZIndex] = useState({});

  useEffect(() => {
    
    const checkActiveModals = () => {
      const savedActiveModal = sessionStorage.getItem("activeModal");
      if (savedActiveModal) {
        let modals = [];
        try {
          const parsed = JSON.parse(savedActiveModal);
          if (Array.isArray(parsed)) {
            modals = parsed;
          } else if (typeof parsed === 'string') {
          
            modals = [parsed];
          }
        } catch (e) {
         
          modals = savedActiveModal ? [savedActiveModal] : [];
        }
        
        if (JSON.stringify(modals.sort()) !== JSON.stringify(activeModals.sort())) {
          setActiveModals(modals);
        }
      } else {
        if (activeModals.length > 0) {
          setActiveModals([]);
        }
      }
      
      const savedStatus = sessionStorage.getItem("webrtcPhoneStatus");
      if (savedStatus && savedStatus !== status) {
        setStatus(savedStatus);
      }
    };

    const interval = setInterval(checkActiveModals, 500);
    return () => clearInterval(interval);
  }, [activeModals, status]);

  useEffect(() => {
    if (activeModals.length > 0) {
      sessionStorage.setItem("activeModal", JSON.stringify(activeModals));
      // Initialize z-index for new modals
      setZIndex(prev => {
        const newZIndex = { ...prev };
        activeModals.forEach(modalType => {
          if (!newZIndex[modalType]) {
            const currentHighest = Object.values(newZIndex).length > 0 ? Math.max(...Object.values(newZIndex)) : 9999;
            newZIndex[modalType] = currentHighest + 1;
          }
        });
        return newZIndex;
      });
    } else {
      sessionStorage.removeItem("activeModal");
    }
    
    // Dispatch custom event for same-tab listeners
    window.dispatchEvent(new CustomEvent('sessionStorageChange', {
      detail: { key: 'activeModal', value: activeModals }
    }));
  }, [activeModals]);

  useEffect(() => {
    interact('.header-modal-panel').draggable({
      allowFrom: '.panel-header',
      listeners: {
        move(event) {
          const modalId = event.target.id;
          const modalEl = event.target;

          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          const modalRect = modalEl.getBoundingClientRect();
          const modalWidth = modalRect.width;
          const modalHeight = modalRect.height;
          const headerHeight = modalEl.querySelector('.panel-header')?.offsetHeight || 40;

          let x = (parseFloat(modalEl.getAttribute('data-x')) || 0) + event.dx;
          let y = (parseFloat(modalEl.getAttribute('data-y')) || 0) + event.dy;

          const minX = -modalEl.offsetLeft + 0;
          const maxX = viewportWidth - modalEl.offsetLeft - modalWidth;
          x = Math.max(minX, Math.min(x, maxX));

          const minY = -modalEl.offsetTop + 0;
          const maxY = viewportHeight - modalEl.offsetTop - headerHeight;
          y = Math.max(minY, Math.min(y, maxY));

          modalEl.style.transform = `translate(${x}px, ${y}px)`;
          modalEl.setAttribute('data-x', x);
          modalEl.setAttribute('data-y', y);

          setPositions(prev => ({
            ...prev,
            [modalId]: { x, y }
          }));
        }
      }
      // listeners: {
      //   move(event) {
      //     const modalId = event.target.id;
      //     const x = (parseFloat(event.target.getAttribute('data-x')) || 0) + event.dx;
      //     const y = (parseFloat(event.target.getAttribute('data-y')) || 0) + event.dy;

      //     event.target.style.transform = `translate(${x}px, ${y}px)`;
      //     event.target.setAttribute('data-x', x);
      //     event.target.setAttribute('data-y', y);
          
      //     setPositions(prev => ({
      //       ...prev,
      //       [modalId]: { x, y }
      //     }));
      //   }
      // }
    });
  }, []);

  const toggleMinimized = (modalType) => {
    setIsMinimized(prev => ({
      ...prev,
      [modalType]: !prev[modalType]
    }));
  };

  const handleCloseModal = (modalType) => {
    setActiveModals(prev => prev.filter(modal => modal !== modalType));
    setZIndex(prev => {
      const newZIndex = { ...prev };
      delete newZIndex[modalType];
      return newZIndex;
    });
  };

  const bringToFront = (modalType) => {
    const currentHighest = Object.values(zIndex).length > 0 ? Math.max(...Object.values(zIndex)) : 9999;
    setZIndex(prev => ({
      ...prev,
      [modalType]: currentHighest + 1
    }));
  };

  const handleTabSelect = (eventKey) => {
    // Only disposition stays in Agent Tools, others open as separate modals
    if (eventKey === "call_history") {
      const currentModals = JSON.parse(sessionStorage.getItem("activeModal") || "[]");
      if (!currentModals.includes("CALL_HISTORY")) {
        const newModals = [...currentModals, "CALL_HISTORY"];
        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
        setActiveModals(newModals);
      }
      // Bring the modal to front
      bringToFront("CALL_HISTORY");
      // Keep tab on disposition
      setAgentToolsActiveTab("disposition");
    } else if (eventKey === "recents") {
      const currentModals = JSON.parse(sessionStorage.getItem("activeModal") || "[]");
      if (!currentModals.includes("RECENTS")) {
        const newModals = [...currentModals, "RECENTS"];
        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
        setActiveModals(newModals);
      }
      // Bring the modal to front
      bringToFront("RECENTS");
      // Keep tab on disposition
      setAgentToolsActiveTab("disposition");
    } else if (eventKey === "scripts") {
      const currentModals = JSON.parse(sessionStorage.getItem("activeModal") || "[]");
      if (!currentModals.includes("SCRIPTS")) {
        const newModals = [...currentModals, "SCRIPTS"];
        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
        setActiveModals(newModals);
      }
      // Bring the modal to front
      bringToFront("SCRIPTS");
      // Keep tab on disposition
      setAgentToolsActiveTab("disposition");
    } else if (eventKey === "disposition") {
      // Allow switching to disposition tab
      setAgentToolsActiveTab("disposition");
    }
  };

  const getModalPosition = (modalType) => {
    const basePosition = { x: 100, y: 100 };
    const offset = activeModals.indexOf(modalType) * 30; // Offset each modal by 30px
    return positions[`header-modal-${modalType}`] || { 
      x: basePosition.x + offset, 
      y: basePosition.y + offset 
    };
  };


  const renderModal = (modalType) => {
    const position = getModalPosition(modalType);
    const modalIsMinimized = isMinimized[modalType] || false;
    const modalWidth = modalType === "AGENT_TOOLS" ? "700px" : modalType === "WEB" ? "430px" : (modalType === "CALL_HISTORY" || modalType === "RECENTS" || modalType === "SCRIPTS") ? "500px" : "700px";
    const modalZIndex = zIndex[modalType] || 9999;
    
    return (
      <>
        <style>
          {`
            /* Hide scrollbars globally for all modals */
            .header-modal-panel .panel-body,
            .header-modal-panel .panel-body > * {
              scrollbar-width: none; /* Firefox */
              -ms-overflow-style: none; /* IE and Edge */
            }
            .header-modal-panel .panel-body::-webkit-scrollbar,
            .header-modal-panel .panel-body > *::-webkit-scrollbar {
              display: none; /* Chrome, Safari, Opera */
            }
            /* Ensure SweetAlert appears above modals */
            .swal2-container {
              z-index: 99999 !important;
            }
            .swal2-popup {
              z-index: 99999 !important;
            }
          `}
        </style>
      <div
        key={modalType}
        id={`header-modal-${modalType}`}
        className="header-modal-panel floating-panel active"
        data-x={position.x}
        data-y={position.y}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          boxShadow: "0 4px 12px rgba(57, 103, 255, 0.2)",
          backgroundColor: "white",
          height: modalIsMinimized ? "130px" : "auto",
          minHeight: modalIsMinimized ? "130px" : "180px",
          overflowY: modalIsMinimized ? "hidden" : "visible",
          position: "fixed",
          zIndex: modalZIndex,
          width: modalWidth
        }}
      >
        <div
          className="panel-header"
          onClick={() => bringToFront(modalType)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#081d5d",
            position: "relative",
            padding: "8px 12px",
            color: "white",
            fontSize: "18px",
            marginBottom: "8px",
            borderTopRightRadius: "0px",
            cursor: "move"
          }}
        >
          <span
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            {modalType === "WEB" ? "WebRTC/Soft Phone" : ""} 
            {modalType === "CALL_HISTORY" ? "Call History" : ""}
            {modalType === "DISPOSITION" ? "Disposition" : ""}
            {modalType === "AGENT_TOOLS" ? "Agent Tools" : ""}
            {modalType === "RECENTS" ? "Recents" : ""}
            {modalType === "SCRIPTS" ? "Scripts" : ""}
          </span>

          {/* Right controls */}
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <span
              className="minimize-btn"
              onClick={() => toggleMinimized(modalType)}
              style={{
                cursor: "pointer",
                marginRight: "20px",
                fontWeight: "bold",
              }}
            >
              {modalIsMinimized ? (
                <Maximize sx={{ fontSize: 22, color: "white" }} />
              ) : (
                <Minimize sx={{ fontSize: 22, color: "white" }} />
              )}
            </span>
            <span
              className="close-btn"
              onClick={() => handleCloseModal(modalType)}
              style={{ cursor: "pointer" }}
            >
              ×
            </span>
          </div>
        </div>

        {modalType === "WEB" && (
          <div>
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  fontSize: "15px",
                  marginBottom: "4px",
                  background:
                    status === "DISCONNECTED"
                      ? "rgba(255, 69, 58, 0.1)"
                      : "rgba(52, 199, 89, 0.1)",
                  padding: "6px 12px",
                  borderRadius: "20px",
                  border:
                    status === "DISCONNECTED"
                      ? "1px solid rgba(255, 69, 58, 0.3)"
                      : "1px solid rgba(52, 199, 89, 0.3)",
                }}
              >
                <span
                  style={{
                    color: status === "DISCONNECTED" ? "#ff3b30" : "#34c759",
                    marginRight: "6px",
                  }}
                >
                  ●
                </span>
                <span>Call Status:</span>
                <span
                  id="callStatusText"
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginLeft: "6px",
                    color: status === "DISCONNECTED" ? "#ff3b30" : "#34c759",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {status}
                </span>
              </span>
            </div>

            <div
              style={{
                display: modalIsMinimized ? "none" : "block",
                marginTop: "4px",
              }}
            >
              <div
                className="panel-body p-0"
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  height: "490px",
                  // maxHeight: "85vh",
                  borderBottomRightRadius: "0px"
                }}
              >
                <ChatWidget />
              </div>
            </div>
          </div>
        )}
        
        {modalType === "CALL_HISTORY" && (
          <div className="panel-body" style={{ height: "532px", borderBottomRightRadius: "0px" }}>
            <CallHistory />
          </div>
        )}
        
        {modalType === "DISPOSITION" && (
          <div className="panel-body" style={{ height: "600px", overflowY: "scroll", borderBottomRightRadius: "0px" }}>
            <Form />
          </div>
        )}

        {modalType === "AGENT_TOOLS" && (
          <div className="panel-body" style={{ height: "532px", overflowY: "auto", borderBottomRightRadius: "0px", padding: "0", border: "none" }}>
            <style>
              {`
                #agent-tools-tabs .nav-tabs {
                  border-bottom: 2px solid #e9ecef;
                  margin-bottom: 0;
                  padding: 0 10px;
                  background: #f8f9fa;
                  border-radius: 8px 8px 0 0;
                }
                #agent-tools-tabs .nav-link {
                  border: 1px solid rgba(8, 29, 93, 0.2);
                  border-bottom: 3px solid rgba(8, 29, 93, 0.3);
                  color: #6c757d;
                  font-weight: 500;
                  padding: 12px 20px;
                  margin-right: 4px;
                  margin-bottom: 8px;
                  background: transparent;
                  transition: all 0.3s ease;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  border-radius: 8px 8px 0 0;
                }
                #agent-tools-tabs .nav-link:hover {
                  color: #081d5d;
                  background: rgba(8, 29, 93, 0.05);
                  border-bottom-color: rgba(8, 29, 93, 0.3);
                }
                #agent-tools-tabs .nav-link.active {
                  color: #081d5d;
                  background: #ffffff;
                  border-bottom-color: #081d5d;
                  font-weight: 600;
                }
                /* Add border and margin to individual tab buttons by ID */
                #agent-tools-tabs-tab-call_history,
                #agent-tools-tabs-tab-recents,
                #agent-tools-tabs-tab-scripts,
                #agent-tools-tabs-tab-disposition {
                  border: 1px solid rgba(8, 29, 93, 0.2) !important;
                 
                  margin-right: 4px !important;
                  margin-bottom: 8px !important;
                }
                #agent-tools-tabs .tab-content {
                  padding: 10px;
                  background: #ffffff;
                  border: none;
                }
                #agent-tools-tabs .tab-pane {
                  padding: 0;
                  border: none;
                }
                #agent-tools-tabs .tab-content > .active {
                  border: none;
                }
                #agent-tools-tabs .nav-tabs .nav-link.active::after {
                  display: none;
                }
                /* Hide scrollbars */
                #agent-tools-tabs .tab-content,
                #agent-tools-tabs .tab-pane,
                #agent-tools-tabs .tab-pane > div {
                  scrollbar-width: none; /* Firefox */
                  -ms-overflow-style: none; /* IE and Edge */
                }
                #agent-tools-tabs .tab-content::-webkit-scrollbar,
                #agent-tools-tabs .tab-pane::-webkit-scrollbar,
                #agent-tools-tabs .tab-pane > div::-webkit-scrollbar {
                  display: none; /* Chrome, Safari, Opera */
                }
                .header-modal-panel .panel-body {
                  scrollbar-width: none; /* Firefox */
                  -ms-overflow-style: none; /* IE and Edge */
                }
                .header-modal-panel .panel-body::-webkit-scrollbar {
                  display: none; /* Chrome, Safari, Opera */
                }
              `}
            </style>
            <Tabs activeKey={agentToolsActiveTab} id="agent-tools-tabs" className="mb-0" onSelect={handleTabSelect}>
              <Tab 
                eventKey="disposition" 
                title={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FileEarmarkText size={16} />
                    Disposition
                  </span>
                }
              >
                <div style={{ height: "430px", overflowY: "auto" }}>
                  <Form />
                </div>
              </Tab>
              <Tab 
                eventKey="call_history" 
                title={
                  <span style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    borderBottom: activeModals.includes("CALL_HISTORY") ? '2px solid #0d6efd' : 'none',
                    paddingBottom: activeModals.includes("CALL_HISTORY") ? '2px' : '0'
                  }}>
                    <ClockHistory size={16} />
                    Call History
                  </span>
                }
              >
                <div style={{ height: "430px", overflowY: "auto" }}>
                  <CallHistory />
                </div>
              </Tab>
              <Tab 
                eventKey="recents" 
                title={
                  <span style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    borderBottom: activeModals.includes("RECENTS") ? '2px solid #0d6efd' : 'none',
                    paddingBottom: activeModals.includes("RECENTS") ? '2px' : '0'
                  }}>
                    <Clock size={16} />
                    Recents
                  </span>
                }
              >
                <div style={{ height: "430px", overflow: "hidden" }}>
                  <Recents />
                </div>
              </Tab>
              <Tab 
                eventKey="scripts" 
                title={
                  <span style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '8px',
                    borderBottom: activeModals.includes("SCRIPTS") ? '2px solid #0d6efd' : 'none',
                    paddingBottom: activeModals.includes("SCRIPTS") ? '2px' : '0'
                  }}>
                    <FileEarmarkCode size={16} />
                    Scripts
                  </span>
                }
              >
                <div style={{ height: "430px" }} />
              </Tab>
            </Tabs>
          </div>
        )}

        {modalType === "RECENTS" && (
          <div className="panel-body" style={{ height: "532px", overflowY: "auto", borderBottomRightRadius: "0px" }}>
            <Recents />
          </div>
        )}

        {modalType === "SCRIPTS" && (
          <div className="panel-body" style={{ height: "532px", overflowY: "auto", borderBottomRightRadius: "0px" }}>
            <div style={{ height: "430px" }} />
          </div>
        )}

      </div>
      </>
    );
  };

  if (activeModals.length === 0) return null;

  return (
    <>
      {activeModals.map(modalType => renderModal(modalType))}
    </>
  );
};

export default HeaderModals;
